

import { form9DataInfoType } from '@/types/Information/Form9';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form9";
const form9State = namespace("Form9");

@Component
export default class Form9StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @informationState.State
    public fileNumber: string;

    @form9State.State
    public form9Info: form9DataInfoType;

    @form9State.Action
    public UpdateForm9Info!: (newForm9Info: form9DataInfoType) => void  
    
    @form9State.State
    public currentRequisitionId: string;

    @form9State.Action
    public UpdateCurrentRequisitionId!: (newCurrentRequisitionId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    otherPartyNames: string[] = [];
    
    representationOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ];

    requestOptions = [ 'Adjourn a hearing', 'Reset a hearing', 'Other' ];
    abandonTypeOptions = [ 'Appeal', 'Cross Appeal' ];

    state = {
        firstAppellant: null,
        firstRespondent: null,
        filingRequisitionParties:null,
        requisitionType: null,
        reliefSought: null,              
        authorizedName:null,
        selfRepresented:null
    }

    respondentName = ""; 
    updated=0;  
  

    mounted() {
        this.dataReady = false;
        this.extractInfo();
              
    }

    public extractInfo(){     

        if(this.currentRequisitionId){
            this.getForm9Data();
           
        } else {  
            const form9Data = {} as form9DataInfoType;                  

            form9Data.appellants = this.partiesJson.appellants
            form9Data.respondents = this.partiesJson.respondents;
            form9Data.formSevenNumber = this.fileNumber;            
            form9Data.version = this.$store.state.Application.version;  
            form9Data.selfRepresented = this.$store.state.Common.userSelfRepresented;          
            this.UpdateForm9Info(form9Data);
            
            this.saveForm(true);                  
            
        }       

    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];

        for (const respondent of this.form9Info.respondents){
            this.respondentNames.push(respondent.name); 
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form9Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);  
        }
        this.dataReady = true;

    }

    public getForm9Data() {        
       
        this.$http.get('/form9/forms/'+this.currentRequisitionId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form9Data = response.data.data                
                this.UpdateForm9Info(form9Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,
            filingRequisitionParties:null, 
            requisitionType: null,
            reliefSought:null,                 
            authorizedName:null,
            selfRepresented:null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   
        
        this.state.firstAppellant = !this.form9Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form9Info.firstRespondent? false : null; 
        this.state.filingRequisitionParties = this.form9Info.filingRequisitionParties?.length>0 ? null: false;  
        this.state.requisitionType = this.form9Info.requisitionType ? null: false;        
        this.state.reliefSought = !this.form9Info.reliefSought? false : null;     
        this.state.authorizedName = !this.form9Info.authorizedName? false : null;       
        this.state.selfRepresented = this.form9Info.selfRepresented != null? null: false;

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    }    

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form9/forms';

        if (this.currentRequisitionId){
            method = 'put';
            url = '/form9/forms/'+this.currentRequisitionId;               

            if (!draft && !this.checkStates()){
               
                return
                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form9Info,
                    type:'Form9',
                    description:'Requisition'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form9Info,
                    type:'Form9',
                    description:'Requisition'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentRequisitionId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }   

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form9"}) 
    }

}
